import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import * as api from './services/api'
import styles from './healthNews/news.module.css'
import { AppBar, Box, Button } from '@mui/material'
import calendar from '../assets/icons/calendar.svg'
import eye from '../assets/icons/eye.svg'
import person from '../assets/icons/person.svg'
import Loader from 'components/Loader'
import logo from '../assets/icons/logo.svg'
import next from '../assets/icons/next.svg'
import prev from '../assets/icons/prev.svg'
import qrcode from '../assets/images/qrcode.png'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { setVersion } from 'store/versionSlice'

export default function News() {
    const navigate = useNavigate()
    const version = useSelector(state => state.vers.value)

    return (
        <>
            <AppBar
                position="sticky"
                sx={{
                    backgroundColor: '#FFFFFF',
                    padding: '10px',
                    color: '#000000',
                    "@media (max-width: 800px)": {
                        fontSize: '12px'
                    },
                }}
            >
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between'
                }}>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gridGap: '10px',
                        fontWeight: 600
                    }}>
                        <img className={styles.logo} src={logo} />
                        <Box>
                            <div>ระบบข้อมูลสุขภาพกำลังพล สป.</div>
                            <div style={{ fontSize: '12px' }}>เวอร์ชัน {version || '-'}</div>
                        </Box>

                    </Box>
                    <Box>
                        <Button
                            variant='outlined'
                            sx={{
                                color: '#252641',
                                "@media (max-width: 500px)": {
                                    fontSize: '10px',
                                    padding: '5px'
                                },
                            }}
                            onClick={() => { navigate('/login') }}
                        >เข้าสู่ระบบ</Button>
                    </Box>
                </Box>
            </AppBar>

            <Box sx={{
                padding: '2% 10%',
                "@media (max-width: 800px)": {
                    padding: '10px',
                },
            }}>
                <NewsPubilc />
            </Box>

            <AppBar
                position="sticky"
                sx={{
                    top: 'auto',
                    bottom: 0,
                    backgroundColor: '#FFFFFF',
                    padding: '10px',
                    color: '#000000',
                    "@media (max-width: 800px)": {
                        fontSize: '12px'
                    },
                }}
            >
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    "@media (max-width: 500px)": {
                        display: 'grid',
                    },
                }}>
                    <Box sx={{
                        display: 'flex',
                        gridGap: '10px'
                    }}>
                        <img className={styles.logo} src={logo} />
                        <Box sx={{ display: 'grid', gridGap: '10px' }}>
                            <Box sx={{
                                fontWeight: 600
                            }}>
                                <Box>สำนักงานแพทย์ สำนักงานสนับสนุน สำนักงานปลัดกระทรวงกลาโหม</Box>
                                <Box>Office for Medical Service of The Permanent Secretary for Defence (MED)</Box>
                            </Box>

                            <Box>
                                <Box>รายงานปัญหาการใช้งาน</Box>
                                <Box>Line official :
                                    <span
                                        style={{ color: '#33A853', cursor: 'pointer', textDecoration: 'underline' }}
                                        onClick={() => { window.open('https://lin.ee/ojY08TD') }}
                                    > healthsystem.mod</span>
                                </Box>
                            </Box>

                        </Box>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <img src={qrcode} className={styles.qrcode} />
                    </Box>

                </Box>
            </AppBar>
        </>
    )
}

export function NewsPubilc() {

    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)

    const [newsBanner, setNewsBanner] = useState([])
    const [newsRecommend, setNewsRecommend] = useState([])
    const [newsAll, setNewsAll] = useState([])

    const [views, setViews] = useState(0)

    useEffect(() => {
        findNews()
        initial()
    }, [])

    const findNews = async () => {
        setLoading(true)
        let res = await api.findNewsFixToken()
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                let data = res['data']['data'].reverse()
                setNewsAll(data)
                const banner = data.filter((item) =>
                    item.banner_status.toLowerCase().includes('Y'.toLowerCase())
                )
                banner.sort((a, b) => new Date(b.created_date) - new Date(a.created_date));
                setNewsBanner(banner)

                const recommend = data.filter((item) =>
                    item.favorite_status.toLowerCase().includes('Y'.toLowerCase())
                )
                setNewsRecommend(recommend)
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const initial = async () => {
        setLoading(true)
        let res = await api.initial()
        setLoading(false)
        if (res) {
            if (res['data']['code'] == 200) {
                // console.log(res['data'])
                let data = res['data']['data']
                setViews(data?.['new_views'])
                dispatch(setVersion(data?.['version']));
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const convertDate = (dataDate) => {
        const date = new Date(dataDate)
        const optionDate = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        }
        const thaiLocale = 'th-TH';
        const formattedDate = date.toLocaleDateString(thaiLocale, optionDate)

        const newDate = `${formattedDate}`
        return newDate
    }

    return (
        <>
            <Loader loading={loading} />

            {/* {!loading ? <Box sx={{
                display: 'flex',
                justifyContent: 'right',
                color: '#478F96'
            }}>
                จำนวนการเข้าชม <span style={{color: '#000000'}}>: {views} ครั้ง</span> </Box> : null}

            {!loading ? <Box sx={{
                fontWeight: 600,
                color: "#478F96",
                "@media (max-width: 800px)": {
                    textAlign: "center",
                },
            }}>ข่าวสารสุขภาพ</Box> : null} */}

            {!loading ?
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Box sx={{
                        fontWeight: 600,
                        color: "#478F96",
                        "@media (max-width: 800px)": {
                            textAlign: "center",
                        },
                    }}>ข่าวสารสุขภาพ</Box>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'right',
                        color: '#478F96'
                    }}>
                        จำนวนการเข้าชม <span style={{ color: '#000000' }}>: {views.toLocaleString()} ครั้ง</span>
                    </Box>
                </Box>
                : null
            }

            {!loading ? <CustomCarousel>
                {newsBanner.map((i, idx) => {
                    return i
                })}
            </CustomCarousel>
                : null}

            {!loading ? <Box className={styles.fontarea}>
                <Box>บทความที่แนะนำ</Box>
            </Box> : null}

            <Box className={styles.mainarea}>
                {newsRecommend.map((item, index) => (
                    <Box
                        key={index}
                        sx={{ cursor: 'pointer', paddingBottom: '10px' }}
                        onClick={() => {
                            let code = item['new_code']
                            window.open(`/showNews?code=${code}`, '_blank')
                        }}>
                        <Box className={styles.container}>
                            <Box className={styles.container2}>
                                <Box sx={{ margin: 0, background: '#000000' }}>
                                    <Box className={styles.img2}>
                                        <img src={item['images'][0]} />
                                    </Box>
                                </Box>
                                <Box className={styles.titlearea}>
                                    <Button
                                        sx={{
                                            backgroundColor: '#E06262',
                                            color: '#FFFFFF',
                                            fontWeight: 600,
                                            "@media (max-width: 800px)": {
                                                padding: '0 5px',
                                                fontSize: '10px'
                                            },
                                        }}
                                    >{item['remark']}</Button>
                                    <Box className={styles.detail}>{item['new_title']}</Box>
                                    <Box className={styles.title2}>
                                        <Box sx={{ display: 'flex', gridGap: '5px' }}>
                                            <img src={calendar} />
                                            <Box>{convertDate(item['created_date'])}</Box>
                                        </Box>
                                        <Box sx={{ display: 'flex', gridGap: '5px' }}>
                                            <img src={eye} />
                                            <Box>{item['views_total'].toLocaleString()}</Box>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>

                    </Box>
                ))}
            </Box>
            {!loading ? <Box className={styles.fontarea}>
                <Box>บทความทั้งหมด</Box>
            </Box> : null}

            <Box sx={{
                display: 'grid',
                gridGap: '10px'
            }}>
                {newsAll.map((item, index) => (
                    <Box
                        key={index}
                        sx={{
                            cursor: 'pointer',
                            border: '1px solid #D9D9D9',
                            // borderRadius: '10px',
                            padding: '20px',
                            display: 'flex',
                            gridGap: '20px',
                            "@media (max-width: 800px)": {
                                gridGap: '10px',
                                padding: '10px'
                            },
                        }}
                        onClick={() => {
                            let code = item['new_code']
                            window.open(`/showNews?code=${code}`, '_blank')
                        }}>
                        {/* <Box className={styles.container}>
                            <Box className={styles.container2}>
                                <Box sx={{ margin: 0, background: '#000000' }}>
                                    <Box className={styles.img2}>
                                        <img src={item['images'][0]} />
                                    </Box>
                                </Box>
                                <Box className={styles.titlearea}>
                                    <Button
                                        sx={{
                                            backgroundColor: '#E06262',
                                            color: '#FFFFFF',
                                            fontWeight: 600,
                                            "@media (max-width: 800px)": {
                                                padding: '0 5px',
                                                fontSize: '10px'
                                            },
                                        }}
                                    >{item['remark']}</Button>
                                    <Box className={styles.detail}>{item['new_title']}</Box>
                                    <Box className={styles.title2}>
                                        <Box sx={{ display: 'flex', gridGap: '5px' }}>
                                            <img src={calendar} />
                                            <Box>{convertDate(item['created_date'])}</Box>
                                        </Box>
                                        <Box sx={{ display: 'flex', gridGap: '5px' }}>
                                            <img src={eye} />
                                            <Box>{item['views_total']}</Box>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box> */}

                        <Box className={styles.img3} >
                            <img src={item['images'][0]} />
                        </Box>
                        <Box>
                            <Box className={styles.detail1}>{item['new_title']}</Box>
                            <Box className={styles.title3}>
                                <Box sx={{ display: 'flex', gridGap: '5px' }}>
                                    <img src={calendar} />
                                    <Box>{convertDate(item['created_date'])}</Box>
                                </Box>
                                <Box sx={{ display: 'flex', gridGap: '5px' }}>
                                    <img src={eye} />
                                    <Box>จำนวนผู้เข้าชม {item['views_total'].toLocaleString()}</Box>
                                </Box>
                            </Box>
                            <Button
                                sx={{
                                    backgroundColor: '#E06262',
                                    color: '#FFFFFF',
                                    fontWeight: 600,
                                    "@media (max-width: 800px)": {
                                        padding: '0 5px',
                                        fontSize: '10px'
                                    },
                                }}
                            >{item['remark']}</Button>
                        </Box>
                    </Box>
                ))}
            </Box>
        </>
    )
}

function CustomCarousel({ children }) {
    const [activeIndex, setActiveIndex] = useState(0);
    const slideNext = () => {
        setActiveIndex((val) => {
            if (val >= children.length - 1) {
                return 0;
            } else {
                return val + 1;
            }
        });
    };

    const slidePrev = () => {
        setActiveIndex((val) => {
            if (val <= 0) {
                return children.length - 1;
            } else {
                return val - 1;
            }
        });
    };

    const convertDate = (dataDate) => {
        const date = new Date(dataDate)
        const optionDate = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        }
        const thaiLocale = 'th-TH';
        const formattedDate = date.toLocaleDateString(thaiLocale, optionDate)

        const newDate = `${formattedDate}`
        return newDate
    }

    return (
        <Box className="container__slider">
            {children.map((i, idx) => (
                <Box
                    className={"slider__item slider__item-active-" + (activeIndex + 1)}
                    key={idx}
                >
                    <Box sx={{
                        cursor: 'pointer'
                    }}
                        className={styles.container}
                        onClick={() => {
                            let code = i['new_code']
                            window.open(`/showNews?code=${code}`, '_blank')
                        }}
                    >
                        <Box sx={{ margin: 0, background: '#000000' }}>
                            {/* <Box sx={{
                                padding: '1rem',
                                backgroundImage: `url(${i.images[0]})`,
                                backgroundSize: 'cover',
                                maskImage: 'linear-gradient(to top, transparent -80%, black)'
                            }}
                                className={styles.imgHeader}
                            >
                            </Box> */}
                            <Box className={styles.imgHeader}>
                                <img src={i['images'][0]} />
                            </Box>
                        </Box>
                        <Box className={styles.area}>
                            <Box className={styles.header}>
                                <Box>บทความสำคัญ:</Box>
                                <Box>{i?.['new_title']}</Box>
                            </Box>
                            <Box className={styles.title}>
                                <Box sx={{ display: 'flex', gridGap: '5px' }}>
                                    <img src={person} />
                                    <Box>BY ADMIN</Box>
                                </Box>
                                <Box sx={{ display: 'flex', gridGap: '5px' }}>
                                    <img src={calendar} />
                                    <Box>{convertDate(i?.['created_date'])}</Box>
                                </Box>
                                <Box sx={{ display: 'flex', gridGap: '5px' }}>
                                    <img src={eye} />
                                    <Box>{i?.['views_total']}</Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            ))}

            <div className="container__slider__links">
                {children.map((item, index) => {
                    return (
                        <button
                            key={index}
                            className={
                                activeIndex === index
                                    ? "container__slider__links-small container__slider__links-small-active"
                                    : "container__slider__links-small"
                            }
                            onClick={(e) => {
                                e.preventDefault();
                                setActiveIndex(index);
                            }}
                        ></button>
                    );
                })}
            </div>

            <button
                className="slider__btn-next"
                onClick={(e) => {
                    e.preventDefault();
                    slideNext();
                }}
            >
                <img src={next} className='buttonIcon' />
            </button>
            <button
                className="slider__btn-prev"
                onClick={(e) => {
                    e.preventDefault();
                    slidePrev();
                }}
            >
                <img src={prev} className='buttonIcon' />
            </button>
        </Box>
    );
}
